import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useHistory, Link } from "react-router-dom";
import Upload from "../../../Input/Upload";
import AlertService from "../../../SweetAlert";
import { newFetch, POST } from "../../../../helpers/fetch";
import ToastUtil from "../../../../components/ToastNotification/ToastUtil";

const AddFeedback = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [files, setFiles] = useState([]);

  const navigateBack = () => {
    history.push("/communications");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validate required fields
    if (!title.trim()) {
      ToastUtil.error(t("Title is required"));
      return;
    }

    if (!description.trim()) {
      ToastUtil.error(t("Description is required"));
      return;
    }

    if (
      await AlertService.confirm(
        "",
        t("Are you sure you want to submit this feedback?")
      )
    ) {
      let formData = new FormData();
      formData.append("title", title);
      formData.append("description", description);

      for (let file of files) {
        formData.append("files[]", file);
      }

      let api_path = `/feedback`;
      let response = await newFetch(POST, api_path, formData, "multi");

      if (response.success) {
        ToastUtil.success(t("Feedback submitted successfully"));
        setTitle("");
        setDescription("");
        setFiles([]);
        navigateBack();
      } else {
        ToastUtil.error(response.message || t("Failed to submit feedback"));
      }
    }
  };

  return (
    <div className="container py-4">
      <div className="row justify-content-center">
        <div className="col-lg-8 col-md-10">
          <h4 className="text-brand">
            <Link to="/communications">
              <i
                className="fas fa-arrow-left link"
                style={{ cursor: "pointer" }}
              />
            </Link>
            &nbsp;&nbsp;{t("Submit Feedback")}
          </h4>
          <div className="card shadow-sm mt-5">
            <div className="card-body p-4">
              <form className="form" onSubmit={(e) => handleSubmit(e)}>
                <div className="form-group mb-3">
                  <label htmlFor="feedbackTitle" className="form-label">
                    {t("Title")} <span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    id="feedbackTitle"
                    name="feedbackTitle"
                    className="form-control"
                    value={title}
                    onChange={({ target: { value } }) => setTitle(value)}
                    placeholder={t("Enter feedback title")}
                  />
                </div>

                <div className="form-group mb-3">
                  <label htmlFor="feedbackDescription" className="form-label">
                    {t("Description")} <span className="text-danger">*</span>
                  </label>
                  <textarea
                    id="feedbackDescription"
                    name="feedbackDescription"
                    className="form-control"
                    rows="5"
                    value={description}
                    onChange={({ target: { value } }) => setDescription(value)}
                    style={{ resize: "none" }}
                    placeholder={t("Enter feedback description")}
                  />
                </div>

                <div className="form-group mb-4">
                  <label htmlFor="feedbackUpload" className="form-label">
                    {t("Upload Files")}{" "}
                    <span className="text-muted">({t("optional")})</span>
                  </label>
                  <Upload files={files} setFiles={setFiles} />
                </div>

                <button
                  type="submit"
                  className="btn btn-design btn-brand btn-block w-100"
                >
                  {t("Submit")}
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddFeedback;
